exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-3ccb3459], .fade-leave-active[data-v-3ccb3459] {\n  opacity: 1;\n  filter: alpha(opacity=100);\n  z-index: 1;\n}\n.fade-enter[data-v-3ccb3459], .fade-leave-to[data-v-3ccb3459] {\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 0;\n  opacity: 0;\n}\n.tab[data-v-3ccb3459] {\n  -webkit-transition: opacity 1s ease;\n  -o-transition: opacity 1s ease;\n  transition: opacity 1s ease;\n}\n", ""]);

// exports
